import { render, staticRenderFns } from "./Function.vue?vue&type=template&id=d79fbac0"
import script from "./Function.vue?vue&type=script&lang=js"
export * from "./Function.vue?vue&type=script&lang=js"
import style0 from "./Function.vue?vue&type=style&index=0&id=d79fbac0&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d79fbac0')) {
      api.createRecord('d79fbac0', component.options)
    } else {
      api.reload('d79fbac0', component.options)
    }
    module.hot.accept("./Function.vue?vue&type=template&id=d79fbac0", function () {
      api.rerender('d79fbac0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/service/ShortsPlatform/components/Function.vue"
export default component.exports